import { inject } from "mobx-react";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

//components
import withLocalization from "../../hoc/withLocalization";
import { checkIfCostUnitHasExpired } from "./Widgets/CostUnitsAndTypes";
import Button from "../CustomButton/CustomButton.jsx";

//elements
import Select from "../../elements/Select";

//utils
import { getShortDateFormat } from "../../utils/dateFormat";

export const COST_UNIT_STATUS = { ACTIVE: 'active', EXPIRED: 'expired', ALL: 'all' };

export const isCostUnitTypeExpired = (row) => checkIfCostUnitHasExpired(row.project.validFrom, row.project.validTo);

export const filterByCostUnitStatus = (rows, status) => {
    if (status === COST_UNIT_STATUS.ALL) return rows;
    const wantExpired = status === COST_UNIT_STATUS.EXPIRED;
    return rows.filter(row => isCostUnitTypeExpired(row) === wantExpired);
};

const CostUnitStatusFilter = ({ t, commonStore, value, onChange, lastUpdated, onRefetch }) => {
    const options = [
        { value: COST_UNIT_STATUS.ACTIVE, label: t('Active') },
        { value: COST_UNIT_STATUS.EXPIRED, label: t('Expired') },
        { value: COST_UNIT_STATUS.ALL, label: t('All') }
    ];
    return (
        <div className='w-100'>
            <div className='d-flex justify-content-space-between align-items-center w-100'>
                <span className='font-size-12'>
                    <strong>{t('Note')}: &nbsp;{t('Please make sure to import the latest data')}</strong>
                    <OverlayTrigger
                        placement='right'
                        overlay={
                            <Tooltip id='tooltip-cost-unit-tips'>
                                <>
                                    <span className='font-size-12'><strong>{t('Cost Units Tips')}</strong></span>
                                    <div className='d-flex justify-content-start'>
                                        <ul className='font-size-10 text-start mb-0 ps-3'>
                                            <li>{t('Changes made over the payroll are not directly reflected, if there is somethings missing then please click on refetch icon and re-sync the cost units')}.</li>
                                            <li>{t('Please make sure that you always use cost units that have valid dates')}.</li>
                                        </ul>
                                    </div>
                                </>
                            </Tooltip>
                        }
                    >
                        <i className='fa fa-info-circle text-muted m-2 opacity-50' aria-hidden='true' />
                    </OverlayTrigger>
                </span>
                <div className='mb-2'>
                    {lastUpdated &&
                        <span className='font-size-12 me-2'>
                            {t('Last Updated')}: {moment(lastUpdated).format(getShortDateFormat(commonStore.getDateTimeRules()))}
                        </span>
                    }
                    <Button icon_sm fill me2
                        onClick={onRefetch}
                        title={t('Refetch cost units')}
                    >
                        <i className="fa fa-sync fa-xl" />
                    </Button>
                </div>
            </div>
            <div className='form-group field field-string mb-2 border-radius-10 w-25'>
                <label className='control-label'>{t('Status')}</label>
                <Select
                    options={options}
                    value={options.find(option => option.value === value)}
                    onChange={option => onChange(option.value)}
                />
            </div>
        </div>
    );
};

export default withLocalization(inject('commonStore')(CostUnitStatusFilter));
